import React, { useEffect, useState } from "react";
import { getBetRecord } from "../../../api/getApi";
import LoadingBetRecord from "../../../components/Loading/LoadingBetRecord";
import NotFound from "../../../components/ProgressBlock/NotFound";
import { formatNumber } from "../../../utils/formatNumber";
import Record from "./Record";

const TotalBet = ({ datePicker }) => {
  const [gameRecord, setGameRecord] = useState([]);
  const [gameOriginRecord, setGameOriginRecord] = useState({}); //這個是遊戲記錄的state
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true); //這個是loading的state
    getBetRecord({
      //這個是獲取遊戲記錄的api
      params: {
        str_date: datePicker.str_date,
        end_date: datePicker.end_date,
      }, //這些日期從datePicker中獲取
    })
      .then((data) => {
        const res = data.data;
        const getKeyArray = Object.keys(res); //当异步操作成功完成后，它处理从服务器返回的数据，并将数据存储在 res 变量中。然后，它使用 Object.keys(res) 获取 res 对象的所有键，将它们存储在 getKeyArray 变量中。
        setGameRecord(
          getKeyArray
            .map((item) => {
              const turnover = res?.[item].totalBet; // 这行代码首先尝试从 gameOriginRecord 对象中获取特定项目（由 item 变量指定）的 totalBet 值。如果 gameOriginRecord 为 null 或 undefined，或者指定的 item 不存在，它将返回 undefined。如果 gameOriginRecord 和 item 存在，并且 totalBet 也存在，那么 turnover 变量将包含 totalBet 的值。
              const winAmount = res?.[item].totalWinOrLose;
              return {
                gameName: item,
                jackpotWin: formatNumber(0),
                bet: formatNumber(turnover),
                winLose: formatNumber(winAmount),
              };
            })
            .filter((item) => parseInt(item.bet) > 0)
        ); //把 getKeyArray 的值存储在名为 gameRecord 的状态变量中。这个变量被用于渲染赌注记录的特定游戏。
        setGameOriginRecord(res); //把从服务器获取的原始数据存储在名为 gameOriginRecord 的状态变量中，以便在组件中使用。
      })
      .catch((err) => {}) //這如果异步操作发生错误，它会执行 .catch() 中的回调函数。这里没有提供错误处理的具体代码，只是留空了。
      .finally(() => {
        setIsLoading(false); // 无论异步操作成功或失败，finally 中的代码都会被执行。在这里，它将 isLoading 设置为 false，表示数据加载完成。
      });
  }, [datePicker]); //useEffect第一个参数是一个回调函数，该函数包含了在组件渲染后执行的代码。第二个参数是一个数组，包含了影响此 useEffect 的依赖项。在这里，useEffect 会在 datePicker 对象发生变化时执行。

  return (
    <LoadingBetRecord commonLoading={isLoading}>
      {gameRecord?.length === 0 ? (
        <NotFound />
      ) : (
        gameRecord.map((item, index) => {
          return (
            <Record
              gameName={item.gameName}
              jackpotWin={0}
              bet={item.bet}
              winLose={item.winLose}
              index={index}
            />
          );
        })
      )}
    </LoadingBetRecord>
  );
};

export default TotalBet;
